import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  name: '',
  email: '',
  nbps: '', //nbps que tiene el user
  saf: '', //saldo a favor que tiene el user
  rfc: '',
  currency: 1, //1=MXN 3=USD
  facturacionAutomatica: true,
  paymentMethod: '', //Actual método de pago seleccionado
  amount: 0, //costo subtotal del carrito
  total: 0, // total del carrito (con IVA)
  
  discount: {nbps: false, saf:0}, //discount.nbps = true or false para saber si quiere usar los nbps
               //discount.saf = valor del saf a usar
  isDealer: false, // bandera para saber si el usuario es distribuidor
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setProfileInfo: (state, action) => {
      const { name, email, nbps, saf, rfc, currency, isDealer } = action.payload;
      state.name = name;
      state.email = email;
      state.nbps = nbps;
      state.saf = saf;
      state.rfc = rfc;
      state.currency = currency;
      state.isDealer = isDealer;
    },
    clearProfileInfo: (state) => {
      return { ...initialState };
    },
    setPaymentMethod: (state, action) => {
      state.paymentMethod = action.payload;
    },
    setAmount: (state, action) => {
      state.amount = action.payload;
    },
    setTotal: (state, action) => {
      state.total = action.payload;
    },
    setDiscountNbps: (state, action) => {
      state.discount.nbps = action.payload;
    },
    setDiscountSaf: (state, action) => {
      state.discount.saf = action.payload;
    },
    setFacturacionAutomatica: (state, action) => {
      state.facturacionAutomatica = action.payload;
    },
    clearProfileDataAfterBuy: (state, action) => {
      state.facturacionAutomatica = initialState.facturacionAutomatica;
      state.discount.nbps = initialState.discount.nbps;
      state.paymentMethod = initialState.paymentMethod;
    }
  },
});

export const { setProfileInfo, clearProfileInfo, setPaymentMethod, setAmount, setDiscountNbps, setDiscountSaf, setFacturacionAutomatica, setTotal, clearProfileDataAfterBuy } = profileSlice.actions;

export default profileSlice.reducer;
